import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import getBrowserPosition from './getBrowserPosition';
import getExperienceFromApi from './getExperienceForPosition';
import { getLocationFromCahce } from './locationCacheManager';

const getExperience = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* ({
    experienceTypes,
    getExperienceForPositionApi,
    cacheDuration,
    locationTimeout,
    hmac,
    time
  }) {
    const locationZipCodes = getLocationFromCahce();
    let position = {};

    if (!locationZipCodes) {
      position = yield getBrowserPosition({
        locationTimeout,
        cacheDuration
      });
    }

    return getExperienceFromApi({
      getExperienceForPositionApi,
      position,
      locationZipCodes,
      experienceTypes,
      cacheDuration,
      hmac,
      time
    });
  });

  return function getExperience(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default getExperience;